import React from 'react'
import PropTypes from 'prop-types'
import {
  Card,
  Col,
  ContentSectionBlock,
  Row
} from 'camino-react'

import FilterPanel from './FilterPanel'

const TicketInvoiceReportCard = ({ children }) => (
  <Card padding="none" allowOverflow>
    <FilterPanel />

    <ContentSectionBlock>
      <Row>
        <Col>
          {children}
        </Col>
      </Row>
    </ContentSectionBlock>
  </Card>
)

TicketInvoiceReportCard.propTypes = {
  children: PropTypes.node
}

TicketInvoiceReportCard.defaultProps = {
  children: null
}

export default TicketInvoiceReportCard
